import { useState, useEffect } from "react";
import { ResponsiveSankey } from "@nivo/sankey";

const FinancialSankey = ({ height, data }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  if (!data || data.length === 0) {
    return <p className="text-center text-gray-500">No financial risk data available</p>;
  }

  //console.log("FINANCIAL DATA", data);

  // Extract financial risk data
  const futureData = data.find((item) => item.assessment_type === "Future") || {};
  const residualData = data.find((item) => item.assessment_type === "Residual") || {};
  const inherentData = data.find((item) => item.assessment_type === "Inherent") || {};

  const inherentLoss = inherentData.estimated_loss || 0;
  const residualLoss = residualData.estimated_loss || 0;
  const acceptedLoss = futureData.estimated_loss || 0;
  const residualSave = inherentLoss - residualLoss;
  const savingFromActions = residualLoss - acceptedLoss;

  // Define nodes
  const nodes = [
    { id: "Loss", name: "Loss" },
    { id: "Residual Loss", name: "Residual Loss" },
    { id: "Residual Savings", name: "Residual Savings" },
    { id: "Accepted Loss", name: "Accepted Loss" },
    { id: "Target Save", name: "Target Save" },
  ];

  // Define links
  const links = [
    { source: "Loss", target: "Residual Loss", value: residualLoss },
    { source: "Loss", target: "Residual Savings", value: residualSave },
    { source: "Residual Loss", target: "Accepted Loss", value: acceptedLoss },
    { source: "Residual Loss", target: "Target Save", value: savingFromActions },
    { source: "Residual Savings", target: "Target Save", value: residualSave },
  ].filter((link) => link.value > 0); // Remove zero-value links

  

  //console.log("Sankey Links:", links);

  return (
    <div className="ml-12 w-full" style={{ height }}>
      <ResponsiveSankey
        data={{ nodes, links }}
        margin={{ top: 40, right: 160, bottom: 40, left: 50 }}
        align="justify"
        colors={{ scheme: "nivo" }}
        nodeOpacity={1}
        nodeHoverOthersOpacity={0.35}
        nodeThickness={18}
        nodeSpacing={24}
        nodeBorderWidth={0}
        nodeBorderRadius={3}
        linkOpacity={0.5}
        linkHoverOthersOpacity={0.1}
        linkContract={3}
        enableLinkGradient={true}
        labelPosition="outside"
        labelOrientation="horizontal"
        labelPadding={16}
        labelTextColor={{ from: "color", modifiers: [["darker", 1]] }}
        animate={true}
        motionConfig="gentle"
        nodeTooltip={({ node }) => (
          <div className="bg-white/90 backdrop-blur-sm shadow-lg rounded-lg p-4 border border-gray-200">
            <strong>{node.name}</strong>: {node.value}
          </div>
        )}
        linkTooltip={({ link }) => (
          <div className="bg-white/90 backdrop-blur-sm shadow-lg rounded-lg p-4 border border-gray-200">
            <strong>{link.source.name}</strong> → {link.target.name}: {link.value}
          </div>
        )}
      />
    </div>
  );
};

export default FinancialSankey;